import React from 'react'

export default function Hero() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section className="relative overflow-hidden -mt-[72px] bg-white">
      {/* Background image — desktop only */}
      <div className="pointer-events-none select-none absolute inset-0 z-0 hidden md:flex justify-center">
        <img
          src="/hero_section.png"
          alt=""
          aria-hidden="true"
          className="h-full w-full max-w-[1440px] object-cover object-center"
        />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-6 pt-[88px] pb-16 md:pt-[152px] md:pb-20 lg:px-8 lg:pt-[184px] lg:pb-28">

        {/* Mobile: image above text */}
        <div className="md:hidden mb-6 overflow-hidden rounded-2xl">
          <img
            src="/hero_section.png"
            alt="Payment solutions"
            className="w-full object-cover object-center"
            style={{ height: '220px' }}
          />
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:items-center">
          {/* Left: Text */}
          <div>
            <h1 className="text-4xl font-bold leading-tight text-gray-900 sm:text-5xl">
              Future-Ready <br />
              <span className="text-indigo-600">Payment Solutions</span>
            </h1>
            <p className="mt-6 text-lg text-gray-600">
              World-class payment solutions, certification, and consulting that simplify compliance and accelerate your product to market.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <button
                onClick={() => scrollTo('contact')}
                className="rounded-lg bg-indigo-600 px-7 py-3 text-base font-semibold text-white hover:bg-indigo-500 transition-colors"
              >
                Get Started
              </button>
              <button
                onClick={() => scrollTo('products')}
                className="rounded-lg border border-gray-300 px-7 py-3 text-base font-semibold text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Learn More
              </button>
            </div>
            <p className="mt-10 text-lg text-gray-600">
              The preferred global partner for payment technology, certification, and compliance empowering businesses to innovate with confidence.
            </p>
          </div>

          {/* Center: empty — lets the POS device in the background image show through */}
          <div className="hidden md:block" />

          {/* Right: Stats */}
          <div className="space-y-8 md:pl-10 md:ml-20">
            <p className="text-2xl font-bold leading-snug text-gray-900 md:text-left">
              Built on Trust.<br />Backed by Numbers.
            </p>
            <div className="space-y-12">
              <div>
                <p className="text-4xl font-bold text-gray-900">900+</p>
                <p className="mt-1 text-sm text-gray-500">Consulting projects delivered</p>
              </div>
              <div className="pl-12">
                <p className="text-4xl font-bold text-gray-900">100+</p>
                <p className="mt-1 text-sm text-gray-500">Acquiring and Issuing Implementations</p>
              </div>
              <div>
                <p className="text-4xl font-bold text-gray-900">20+</p>
                <p className="mt-1 text-sm text-gray-500">Experienced Experts</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
